import { VirtualPackErpResponse } from 'com.cogvio.pricemonitor.api';
import * as React from 'react';

import ERPAveragePriceBadge from './ERPAveragePriceBadge';
import ERPRevenuePriceBadge from './ERPRevenuePriceBadge';

const ERPRevenueSummary = ({
	currency,
	erpModelResult,
	type,
}: {
	currency: string;
	erpModelResult?: VirtualPackErpResponse | null;
	type?: 'big' | 'small';
}) => {
	return (
		<div className='mb-2'>
			<ERPRevenuePriceBadge currency={currency} erpModelResult={erpModelResult} type={type} />
			<ERPAveragePriceBadge currency={currency} erpModelResult={erpModelResult} type={type} />
		</div>
	);
};

export default React.memo(ERPRevenueSummary);
